export default [
  {
    path: "",
    name: "home",
    component: () => import("@/views/dashboard"),
    meta: {
      activeId: 1,
      breadcrumb: ["首页", "实时监控"]
    }
  },
  {
    path: "/about",
    name: "about_cn",
    component: () => import("@/views/about"),
    meta: {
      activeId: 1,
      breadcrumb: ["首页", "正在建设中"]
    }
  }
];
